import createModalsSlice, { initialState } from '@sv-support-sdk/store/src/modules/modals/slices';

const modalsSlice = createModalsSlice({
  name: 'modals',
  initialState: { ...initialState },
  reducers: {},
});

export const { openModal, closeModal } = modalsSlice.actions;

export default modalsSlice.reducer;
